module.exports = __webpack_public_path__ + "img/spyder-product-showcase.bebf64f1.png";